import axiosInstance from './axiosInstance';

const getClientPaycloudConfigData = (clientId) =>
  axiosInstance.get(`/internal/admin/clients/${clientId}/paycloud/config`);

export default getClientPaycloudConfigData;
